
import { z } from "zod";

export const ComplexityTypeValues = ["LOW", "MEDIUM", "HIGH", "PRE_COMPLEXITY_INPUT", "LOW_8", "MEDIUM_11", "HIGH_16"] as const;
export const ComplexityTypeSchema = z.enum(ComplexityTypeValues);
export const ComplexityType = ComplexityTypeSchema.enum;
export type ComplexityType = (typeof ComplexityTypeValues)[number];
